import ShareableLinksMobileItem from './ShareableLinksMobileItem.component';

export default ShareableLinksMobileItem;
